import SEO from "../components/SEO";
import { PatientHeader } from "../components/PatientHeader";
import { QuiltAppIcon } from "../components/QuiltLogo";
import { DownloadQr, StoreButton } from "../components/StoreDownload";

/**
 * quilt.gg/download, the target of our QR codes. Phones never see this page: index.html sends iPhones/iPads to
 * /appstore and Android to /playstore before the app even loads. Everyone else (desktop) gets both options here.
 */
export default function DownloadPage() {
    return (
        <div className="relative z-10 min-h-screen text-slate-900 dark:text-white">
            <SEO title="Quilt" description="Download Quilt on the App Store or Google Play." path="/download" noindex />
            <PatientHeader />

            <section className="flex min-h-[calc(100vh-4rem)] items-center justify-center px-4 pb-16 pt-28 md:pt-32">
                <div className="w-full max-w-xl rounded-3xl border border-purple-200/70 bg-gradient-to-br from-white via-purple-50/60 to-white p-6 text-center shadow-xl shadow-purple-100/50 sm:p-10 dark:border-purple-500/20 dark:from-zinc-900 dark:via-purple-950/20 dark:to-zinc-900 dark:shadow-none">
                    <QuiltAppIcon className="mx-auto mb-6 h-16 w-16" />
                    <h1 className="text-4xl font-light leading-tight text-slate-900 md:text-5xl dark:text-white">Quilt</h1>
                    <p className="mx-auto mt-3 max-w-sm font-light leading-relaxed text-slate-600 dark:text-zinc-400">
                        Download the app on your phone to get started.
                    </p>

                    <div className="mx-auto mt-8 flex max-w-sm flex-col gap-3 sm:max-w-none sm:flex-row sm:justify-center">
                        <StoreButton store="apple" className="sm:min-w-[200px]" />
                        <StoreButton store="google" className="sm:min-w-[200px]" />
                    </div>

                    {/* On a computer, the quickest way onto a phone is to scan */}
                    <div className="mt-10 hidden border-t border-slate-200 pt-8 md:block dark:border-zinc-800">
                        <p className="mb-5 text-sm text-slate-500 dark:text-zinc-400">Or scan with your phone's camera</p>
                        <div className="flex justify-center">
                            <DownloadQr size="lg" caption="" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
